import { Company } from 'models'
import { ORPHAN_PARENT_COMPANY } from '../constants'

type ResolveB2CContextInput = {
  isLoginB2C: boolean
  assignedCompany: Company | null
  assignedParentCompany: Company | null
}

type B2CContext = {
  userCompany: Company | null
  b2cAutoSelectedChildId: string
  b2cAutoSelectedChild: Company | null
  isB2CNoFamily: boolean
}

const defaultB2CContext: B2CContext = {
  userCompany: null,
  b2cAutoSelectedChildId: '',
  b2cAutoSelectedChild: null,
  isB2CNoFamily: false,
}

const resolveB2CContext = ({
  isLoginB2C,
  assignedCompany,
  assignedParentCompany,
}: ResolveB2CContextInput): B2CContext => {
  if (!isLoginB2C || !assignedCompany) {
    return defaultB2CContext
  }

  const assignedParentId = assignedCompany.parentId?.trim() || ''
  const isB2CNoFamily = !assignedParentId

  return {
    userCompany: isB2CNoFamily ? ORPHAN_PARENT_COMPANY : assignedParentCompany,
    b2cAutoSelectedChildId: assignedCompany.id || '',
    b2cAutoSelectedChild: assignedCompany,
    isB2CNoFamily,
  }
}

export { resolveB2CContext }
